import { useCallback, useState } from 'react';
var useHasScroll = function () {
    var _a = useState(false), hasScrollLeft = _a[0], setHasScrollLeft = _a[1];
    var _b = useState(false), hasScrollRight = _b[0], setHasScrollRight = _b[1];
    var setHasScroll = useCallback(function (element) {
        if (element) {
            setHasScrollLeft(element.scrollLeft > 0);
            // This should be === 0, but the round algorithms do not work consistently with scrollWidth and offsetWidth
            setHasScrollRight(Math.abs(element.scrollWidth - element.scrollLeft - element.offsetWidth) > 1);
        }
    }, []);
    return { hasScrollLeft: hasScrollLeft, hasScrollRight: hasScrollRight, setHasScroll: setHasScroll };
};
export default useHasScroll;
